<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="fill-height">
    <v-row class="flex-child fill-height" style="max-width: none;">
      <v-col cols="12" md="3">
        <v-sheet class="fill-height" elevation="2">
          <v-row>
            <v-col cols="12" md="4">
              <v-chip class="ma-2 Headline" color="primary">
                <!-- //菜单预览 -->
                {{ $vuetify.lang.t('$vuetify.custom.menu.menuPreview') }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row align="center" class="my-4" justify="center">
            <v-col cols="12" md="10">
              <v-card>
                <v-responsive class="overflow-y-auto" max-height="400">
                  <v-list subheader :disabled="listDisabled">
                    <v-list-item-group :mandatory="mandatory" v-model="selected">
                      <template v-for="item in items">
                        <v-list-group v-if="item.items && item.items.length != 0" :value="item.show" :key="item.id"
                          no-action @click="itemClick(item)">
                          <template v-slot:activator>
                            <v-list-item-icon>
                              <v-icon v-if="item.iconType === '0'">{{item.icon}}</v-icon>
                              <v-avatar size="24px" v-else>
                                <img :src="iconShow(item.icon)">
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <template v-for="ite in item.items">
                            <v-list-item :key="ite.id" @click="itemClick(ite)">
                              <v-list-item-icon>
                                <v-icon v-if="ite.iconType === '0'">{{ite.icon}}</v-icon>
                                <v-avatar size="24px" v-else>
                                  <img :src="iconShow(ite.icon)">
                                </v-avatar>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title v-text="ite.name"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-list-group>
                        <v-list-item v-else :key="item.id" @click="itemClick(item)">
                          <v-list-item-icon>
                            <v-icon v-if="item.iconType  === '0'">{{item.icon}}</v-icon>
                            <v-avatar size="24px" v-else>
                              <img :src="iconShow(item.icon)">
                            </v-avatar>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-responsive>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-row align="center" justify="center">
                <v-col cols="12" md="3" v-if="itemOrder">
                  <v-row align="center" justify="center">
                    <v-btn class="mx-2" x-small fab color="error" @click="rollbackItem">
                      <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3">
                  <v-row align="center" justify="center">
                    <v-btn class="mx-2" x-small :disabled="itemOrderUpShow" fab color="primary" @click="updateOrder('up')">
                      <v-icon>mdi-chevron-double-up</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3">
                  <v-row align="center" justify="center">
                    <v-btn class="mx-2" x-small :disabled="itemOrderDownShow" fab color="primary" @click="updateOrder('down')">
                      <v-icon>mdi-chevron-double-down</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3" v-if="itemOrder">
                  <v-row align="center" justify="center">
                    <v-btn class="mx-2" x-small fab color="success" @click="saveItemOrders">
                      <v-icon>mdi-check-bold</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet class="fill-height" elevation="2">
          <v-row>
            <v-col cols="12" md="4">
              <v-chip class="ma-2 Headline" color="success">
                {{label.addMenu}}
              </v-chip>

              <v-chip class="ma-2 Headline float-right" color="error" v-if="!saveDisabled" @click="rollbackItem">
                <v-icon>mdi-backup-restore</v-icon>
                {{label.cancelOperation}}
              </v-chip>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-card>
                <v-form ref="form">
                  <v-container fluid class="fill-height">
                    <v-row>
                      <v-col>
                        <v-text-field :disabled="textDisabled" :rules="[rules.required]" hide-details :label="label.name"
                          v-model="formData.name" @input="nameChange" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field :disabled="textDisabled" hide-details :label="label.href" v-model="formData.href" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field :disabled="textDisabled" :rules="[rules.required]" hide-details :label="label.code"
                          v-model="formData.code" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row justify="center">
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="primary" @click="updateItem">
                            <v-icon dark>mdi-pencil</v-icon>
                            {{label.update}}
                          </v-btn>
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="error" @click="deleteMenu">
                            <v-icon dark>mdi-delete</v-icon>
                            {{label.delete}}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row justify="center">
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="success" @click="addMenuBtn()">
                            <v-icon dark>mdi-plus-thick</v-icon>
                            {{label.add}}
                          </v-btn>
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="success" @click="addSubBtn()">
                            <v-icon dark>mdi-plus-thick</v-icon>
                            {{label.addSub}}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-row v-if="!textDisabled">
                  <v-col cols="12">
                    <v-tabs grow v-model="formData.iconType" @change="iconTypeChange">
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab href="#0">{{label.icon}}</v-tab>
                      <v-tab href="#1">{{label.img}}</v-tab>
                      <v-tab-item value="0">
                        <v-card>
                          <icon-selector :height="200" @change="iconChange" v-model.lazy="formData.icon"></icon-selector>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="1">
                        <v-card height="300">
                          <v-container fluid class="fill-height">
                            <v-row justify="center">
                              <v-avatar size="128px">
                                <img :src="formData.icon">
                              </v-avatar>
                            </v-row>
                            <v-row justify="center">
                              <v-col md="6">
                                <v-file-input accept="image/*" v-model="file" @change="fileChange" :label="label.file"></v-file-input>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-btn class="mb-3" large width="90%" :disabled="saveDisabled" color="success" @click="saveItem">{{label.save}}</v-btn>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">

            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<style></style>
<script>
  import IconSelector from '@/components/icon/IconSelector'
  import Mock from 'mockjs'

  export default {
    data() {
      return {
        //是否可以排序
        itemOrderUpShow: true,
        itemOrderDownShow: true,
        //是否操作排序
        itemOrder: false,
        //文本操作状态   可用作图标的显示
        textDisabled: true,
        //操作区按钮
        buttonsDisabled: true,
        //保存按钮
        saveDisabled: true,
        //列表是否禁用
        listDisabled: false,


        selected: '',
        //是否强制选中一项
        mandatory: false,
        //是修改还是添加
        isUpdate: true,

        label: {
          name: this.$vuetify.lang.t('$vuetify.custom.menu.menuName'),//'菜单名字',
          href: this.$vuetify.lang.t('$vuetify.custom.menu.routerAddress'),//'路由地址',
          code: this.$vuetify.lang.t('$vuetify.custom.menu.authorityCode'),//'权限编码',
          update: this.$vuetify.lang.t('$vuetify.custom.menu.updateMenu'),//'修改菜单',
          delete: this.$vuetify.lang.t('$vuetify.custom.menu.deleteMenu'),//'删除菜单',
          add: this.$vuetify.lang.t('$vuetify.custom.menu.addPeer'),//'新增同级',
          addSub: this.$vuetify.lang.t('$vuetify.custom.menu.addSubset'),//'新增子集',
          icon: this.$vuetify.lang.t('$vuetify.custom.icon'),//'图标',
          img: this.$vuetify.lang.t('$vuetify.custom.image'),//'图片',
          save: this.$vuetify.lang.t('$vuetify.custom.preservation'),//'保存',
          cancel: this.$vuetify.lang.t('$vuetify.custom.cancelBtn'),//'取消',
          file: this.$vuetify.lang.t('$vuetify.custom.pleaseSelectImageFile'),//'请选择图像文件',
          addMenu: this.$vuetify.lang.t('$vuetify.custom.menu.menuOperation'),//'菜单操作',
          cancelOperation: this.$vuetify.lang.t('$vuetify.custom.giveUpOperation'),//'放弃操作'
          updateSuccess:this.$vuetify.lang.t('$vuetify.custom.updateSuccess'),//修改成功
          addSuccess:this.$vuetify.lang.t('$vuetify.custom.addSuccess'),//添加成功
        },
        items: [],
        itemsOld: [],
        formData: {
          id: '',
          name: '',
          href: '',
          code: '',
          permissionOrder: '',
          icon: '',
          iconType: '0',
          parentId: ''
        },
        rules: {
          required: value => !!value || this.$vuetify.lang.t('$vuetify.custom.pleaseEnery')
        },
        file: {}
      }
    },

    created() {
      //this.$store.commit('changeDrawerOff');
      this.loadMenu();
    },
    mounted() {
      this.$store.commit('changeDrawerOff');
    },
    computed: {
      iconShow(icon) {
        return function(icon) {
          if (icon.length == 32) {
            return this.$file.fileDownload(icon)
          }
          return icon
        }
      }
    },
    methods: {
      loadMenu() {
        this.$api.sysPermission.selectMenuList().then(data => {
          this.items = this.$utils.menu.sortMenu(data.data)
          this.itemsOld = this.$utils.arrayUtil.deepClone(this.items);
          //this.$store.commit('setMenuItems',this.itemsOld);
        })
        this.reloadStatus()
      },
      iconTypeChange(iconType) {
        this.formData.iconType = iconType
        this.formData.icon = ''
      },
      nameChange() {
        this.changeItem()
      },
      iconChange() {
        this.changeItem()
      },
      fileChange(file) {
        let reader = new FileReader();
        let vueMe = this;
        reader.addEventListener("load", function() {
          let src = reader.result;
          vueMe.formData.icon = src;
          vueMe.changeItem()
        }, false);
        reader.readAsDataURL(file);
      },
      rollbackItem() {
        this.listDisabled = false
        this.selected = ""
        this.mandatory = false
        this.items = this.$utils.arrayUtil.deepClone(this.itemsOld);
        this.$utils.objectEmpty(this.formData)
        this.reloadStatus()
      },
      itemClick(item) {
        this.mandatory = true
        this.buttonsDisabled = false
        this.formData.id = item.id
        this.formData.name = item.name
        this.formData.href = item.href
        this.formData.icon = item.icon
        this.formData.iconType = item.iconType
        this.formData.permissionOrder = item.permissionOrder
        this.formData.code = item.code
        this.orderButtonStatus()
      },
      updateItem() {
        this.isUpdate = true
        this.updateButtonStatus()
      },
      addMenuBtn() {
        this.isUpdate = false
        this.updateButtonStatus()
        let fit = this.findItem()
        let order
        let id = new Date().getTime()
        let tar
        let parentId
        if (fit.subNum == -1) {
          order = parseInt(this.items[this.items.length - 1].permissionOrder) + 1
          tar = this.items
          parentId = ''
        } else {
          order = parseInt(this.items[fit.num].items[this.items[fit.num].items.length - 1].permissionOrder) + 1
          tar = this.items[fit.num].items
          parentId = this.items[fit.num].id
        }
        this.pushItem(tar, id, order, parentId)
        this.selected = ""
        this.mandatory = false
      },
      addSubBtn() {
        this.isUpdate = false
        this.updateButtonStatus()
        let fit = this.findItem()
        if (fit.subNum != -1) {
          this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.menu.theCtNCAStPtPTAgain'), this.$vuetify.lang.t('$vuetify.custom.error'))
          this.rollbackItem()
        } else {
          let order
          if (this.items[fit.num].items.length === 0) {
            order = 0
          } else {
            order = parseInt(this.items[fit.num].items[this.items[fit.num].items.length - 1].permissionOrder) + 1
          }
          this.items[fit.num].show = true
          this.pushItem(this.items[fit.num].items, new Date().getTime(), order, this.items[fit.num].id)
          this.selected = ""
          this.mandatory = false
        }
      },
      async saveItem() {
        if (this.$refs.form.validate()) {
          let icon
          if (this.formData.iconType === '1') {
            let from1 = new FormData();
            from1.append("filePath", "menu");
            from1.append('file', this.file);
            let file = await this.$file.fileUpload(from1)
            icon = file.fileId
          } else {
            icon = this.formData.icon
          }
          this.formData.icon = icon
          if (this.isUpdate) {
            this.$api.sysPermission.updateMenu(this.formData).then(data => {
              if (data.flag) {
                this.$dialog.alert(this.label.updateSuccess);
                this.loadMenu()
              }
            })
          } else {
            this.$api.sysPermission.addMenu(this.formData).then(data => {
              if (data.flag) {
                this.$dialog.alert(this.label.addSuccess);
                this.loadMenu()
              }
            })
          }
        }
      },
      saveItemOrders() {
        let orderItems = []
        for (let i = 0; i < this.items.length; i++) {
          orderItems.push({
            'id': this.items[i].id,
            'permissionOrder': this.items[i].permissionOrder
          })
          if (this.items[i].items.length != 0) {
            for (let j = 0; j < this.items[i].items.length; j++) {
              orderItems.push({
                'id': this.items[i].items[j].id,
                'permissionOrder': this.items[i].items[j].permissionOrder
              })
            }
          }
        }
        this.$api.sysPermission.updateMenuOrder(
          orderItems
        ).then(data => {
          if (data.flag) {
            this.loadMenu()
          }
        })
      },
      updateOrder(order) {
        this.buttonsDisabled = true
        let fit = this.findItem()
        let temp = ''
        this.itemOrder = true
        if (fit.num != -1) {
          if (order === 'up') {
            if (fit.subNum != -1) {
              temp = this.items[fit.num].items[fit.subNum].permissionOrder
              this.items[fit.num].items[fit.subNum].permissionOrder = this.items[fit.num].items[fit.subNum - 1].permissionOrder
              this.items[fit.num].items[fit.subNum - 1].permissionOrder = temp
            } else {
              temp = this.items[fit.num].permissionOrder
              this.items[fit.num].permissionOrder = this.items[fit.num - 1].permissionOrder
              this.items[fit.num - 1].permissionOrder = temp
            }
          } else {
            if (fit.subNum != -1) {
              temp = this.items[fit.num].items[fit.subNum].permissionOrder
              this.items[fit.num].items[fit.subNum].permissionOrder = this.items[fit.num].items[fit.subNum + 1].permissionOrder
              this.items[fit.num].items[fit.subNum + 1].permissionOrder = temp
            } else {
              temp = this.items[fit.num].permissionOrder
              this.items[fit.num].permissionOrder = this.items[fit.num + 1].permissionOrder
              this.items[fit.num + 1].permissionOrder = temp
            }
          }
        }
        this.items = this.$utils.menu.sortMenu(this.items)
        this.orderButtonStatus()
      },
      deleteMenu() {
        let fit = this.findItem()
        let text = this.$vuetify.lang.t('$vuetify.custom.menu.canYCDTCMenu')
        if (fit.subNum === -1) {
          if (this.items[fit.num].items.length != 0) {
            text = this.$vuetify.lang.t('$vuetify.custom.menu.canYCDTCSubMenu')
          }
        }
        this.$dialog.confirm(text,'提示', () => {
          this.$api.sysPermission.deletePermission(
            this.formData.id
          ).then(data => {
            if (data.flag) {
              this.loadMenu()
            }
          })
        })
      },
      /**
       * 下面的是公共方法
       */
      //查找元素所在位置
      findItem() {
        let num = -1
        let subNum = -1
        for (let i = 0; i < this.items.length; i++) {
          if (this.formData.id === this.items[i].id) {
            num = i
            break
          }
          if (this.items[i].items) {
            for (let j = 0; j < this.items[i].items.length; j++) {
              if (this.formData.id === this.items[i].items[j].id) {
                num = i
                subNum = j
                break
              }
            }
            if (subNum != -1) {
              break
            }
          }
        }
        return {
          num: num,
          subNum: subNum
        }
      },
      //更改预览实时显示
      changeItem() {
        let fit = this.findItem()
        if (fit.num != -1) {
          let item = this.items[fit.num];
          if (fit.subNum != -1) {
            let subArray = item.items;
            subArray.splice(fit.subNum, 1, {
              id: this.formData.id,
              name: this.formData.name,
              icon: this.formData.icon,
              iconType: this.formData.iconType,
            })
            item.items = subArray
          } else {
            item.name = this.formData.name
            item.icon = this.formData.icon
            item.iconType = this.formData.iconType
          }
          this.items.splice(fit.num, 1, item)
        }
      },
      //状态重置
      reloadStatus() {
        this.itemOrderUpShow = true
        this.itemOrderDownShow = true
        this.itemOrder = false
        this.textDisabled = true
        this.buttonsDisabled = true
        this.saveDisabled = true
        this.listDisabled = false
        this.mandatory = false
        this.selected = ""
      },
      //排序按钮状态
      orderButtonStatus() {
        this.itemOrderDownShow = false
        this.itemOrderUpShow = false
        let fit = this.findItem()
        if (fit.num != -1) {
          if (fit.subNum != -1) {
            let arrays = this.items[fit.num].items
            if (fit.subNum === 0) {
              this.itemOrderUpShow = true
            }
            if (fit.subNum === arrays.length - 1) {
              this.itemOrderDownShow = true
            }
          } else {
            let arrays = this.items
            if (fit.num === 0) {
              this.itemOrderUpShow = true
            }
            if (fit.num === arrays.length - 1) {
              this.itemOrderDownShow = true
            }
          }
        }
      },
      //操作区按钮点击后状态
      updateButtonStatus() {
        this.itemOrderUpShow = true
        this.itemOrderDownShow = true
        this.buttonsDisabled = true
        this.textDisabled = false
        this.saveDisabled = false
        this.listDisabled = true
      },
      //新增默认值
      pushItem(arr, id, order, parentId) {
        arr.push({
          id: id,
          name: '',
          herf: '',
          icon: 'mdi-book-account',
          iconType: '0',
          permissionOrder: order,
          code: ''
        })
        this.formData.id = id
        this.formData.name = ''
        this.formData.href = ''
        this.formData.icon = 'mdi-book-account'
        this.formData.iconType = '0'
        this.formData.permissionOrder = order
        this.formData.code = ''
        this.formData.parentId = parentId
      },
    },
    components: {
      IconSelector
    },
  }
</script>
